import React, { useState, useEffect } from "react";

import ObservationForm from "../components/observation/ObservationForm";
import { TLoadable, createUnloaded, isLoaded, isUnloaded, createLoaded } from "../../../sg-core";
import { useAnonPackage, useLoginStatus } from "../auth/store/authSelectors";
import { useDispatch } from "react-redux";
import { createRequestFetchInitalAppContext } from "../store/actions/contextActions";
import { Segment, Header, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { PageTemplate } from "../components/PageTemplate/PageTemplate";

interface IAnonymousObservationPage {
    formTypeId: number;
}

const AnonymousObservationPage: React.FC<IAnonymousObservationPage> = ({ formTypeId }) => {
    const [submitted, setSubmitted] = useState<boolean>(false);
    const { t } = useTranslation();

    if (submitted) {
        return (
            <Segment textAlign="center" padded="very">
                <Header icon>
                    <Icon name="check" color="green" />
                    {t("Tallennus onnistui")}
                </Header>
                <p>{t("Havainto tallennettiin onnistuneesti ja odottaa käsittelijää.")}</p>
                <p>{t("Voit sulkea tämän sivun.")}</p>
            </Segment>
        );
    }

    return (
        <PageTemplate>
            <Segment basic>
                <ObservationForm
                    formTypeGuid={formTypeId}
                    userRequired={false}
                    canCancel={false}
                    onSuccess={() => setSubmitted(true)}
                />
            </Segment>
        </PageTemplate>
    );
};

const MemoizedAnonymousObservationPage = React.memo(AnonymousObservationPage);

const AnonymousObservationPageContainer: React.FC = () => {
    const loginStatus = useLoginStatus();
    const [formTypeId, setFormTypeId] = useState<TLoadable<number>>(createUnloaded());
    const anonPackage = useAnonPackage();
    const dispatch = useDispatch();

    useEffect(() => {
        if (isUnloaded(formTypeId) && anonPackage) {
            setFormTypeId(createLoaded(anonPackage));
            dispatch(createRequestFetchInitalAppContext());
        }
    }, [formTypeId, loginStatus, anonPackage]);

    if (!isLoaded(formTypeId)) {
        return <div>Haetaan lomaketta...</div>;
    }

    return <MemoizedAnonymousObservationPage formTypeId={formTypeId.data} />;
};

export default AnonymousObservationPageContainer;
